import {
  BaseCompanyRequest,
  DocumentDTO,
  DocumentDTOListApiData,
  FolderDTO,
  FolderDTOListApiData,
  GetDocumentsRequest,
} from '../api/data-contracts'
import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { RootState } from './store'
import { postRequestAsync } from './commonSlice'
import { Api_Document_GetFiles, Api_Document_GetFolders } from '../apiClient/apiClient'

export interface DocumentState {
  folders: FolderDTO[] | null | undefined
  documents: DocumentDTO[] | null | undefined
  selectedFolder: FolderDTO | null | undefined
}

const initialState: DocumentState = {
  documents: null,
  folders: null,
  selectedFolder: null,
}

export const documentSlice = createSlice({
  name: 'document',
  initialState: initialState,
  reducers: {
    setFolders: (state, action: PayloadAction<FolderDTO[] | null | undefined>) => {
      state.folders = action.payload
    },
    setDocuments: (state, action: PayloadAction<DocumentDTO[] | null | undefined>) => {
      state.documents = action.payload
    },
    setSelectedFolder: (state, action: PayloadAction<FolderDTO | null | undefined>) => {
      state.selectedFolder = action.payload
    },
  },
})

export const loadFolders = createAsyncThunk('api/loadFolders', async (payload, thunkAPI) => {
  const adminState = (thunkAPI.getState() as RootState).admin
  const companyState = (thunkAPI.getState() as RootState).company
  const request: BaseCompanyRequest = {
    companyGuidId: adminState?.company?.company?.guid ?? companyState?.Id ?? '',
  }
  thunkAPI
    .dispatch<any>(
      postRequestAsync({
        postRequestFunction: Api_Document_GetFolders,
        body: request,
      })
    )
    .unwrap()
    .then((response: FolderDTOListApiData) => {
      thunkAPI.dispatch(setFolders(response.data))
    })
})

export const loadDocuments = createAsyncThunk('api/loadDocuments', async (payload, thunkAPI) => {
  const documentState = (thunkAPI.getState() as RootState).document
  const adminState = (thunkAPI.getState() as RootState).admin
  const companyState = (thunkAPI.getState() as RootState).company

  const body: GetDocumentsRequest = {
    documentTypeId: documentState.selectedFolder?.id ?? 0,
    companyGuidId: adminState?.company?.company?.guid ?? companyState?.Id ?? '',
  }

  thunkAPI
    .dispatch<any>(
      postRequestAsync({
        postRequestFunction: Api_Document_GetFiles,
        body,
      })
    )
    .unwrap()
    .then((response: DocumentDTOListApiData) => {
      thunkAPI.dispatch(setDocuments(response.data))
    })
})

export const {setFolders, setDocuments, setSelectedFolder} = documentSlice.actions
export default documentSlice.reducer

export const getDocumentState = (state: RootState) => state.document
